import { ConsentManager } from '@vgtv/consent-manager';

let consentManager: ConsentManager | undefined;

export const getConsentManager = (): ConsentManager => {
    if (!consentManager) {
        consentManager = new ConsentManager({ allowlist: ['CMP:advertising'] });
    }

    return consentManager;
};
